'use client';

import { ISalePageDetailV2Response } from '@/api/types';
import { Column, Element } from '@vuddy/components';
import { SellerInfoSection } from '../sellerInfo';
import { ClassPurchaseGuide } from './ClassPurchaseGuide';
import { ComprehensivePurchaseGuide } from './ComprehensivePurchaseGuide';
import * as styles from './purchaseGuideSection.css';
import { RandomMediaGuide } from './RandomMediaGuide';

interface SalePagePurchaseGuideProps {
  salePage?: Partial<ISalePageDetailV2Response>;
  salePageId?: number;
}

export const SalePagePurchaseGuide = ({
  salePage,
  salePageId,
}: SalePagePurchaseGuideProps) => {
  const isClass = (salePage?.type as string) === 'CLASS';

  return (
    <Column
      id="purchase-guide"
      className={styles.wrapper}
      paddingBottom="gap_7xl"
      gap="gap_4xl">
      <Element typography="titleSmall">구매 안내</Element>
      {salePageId && (
        <SellerInfoSection salePageId={salePageId} salePage={salePage} />
      )}
      {isClass ? (
        <ClassPurchaseGuide salePage={salePage} />
      ) : (
        <>
          <ComprehensivePurchaseGuide salePage={salePage} />
          <RandomMediaGuide salePage={salePage} />
        </>
      )}
    </Column>
  );
};
